import { configureStore } from "@reduxjs/toolkit";
import { sessionReducer } from "@features/auth/model/session-slice";

// Redux Toolkit = state ที่ข้าม feature และต้องคงอยู่ (แบรนด์/แคมเปญที่เลือก, session)
// Zustand = state ชั่วคราวของ UI · TanStack Query = ทุกอย่างที่มาจาก server
// (แบ่งหน้าที่ตาม docs/REFACTOR-PLAN.md ข้อ 0.1 — อย่าให้ทับกัน)
export const store = configureStore({
  reducer: {
    session: sessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
